// extracted by mini-css-extract-plugin
module.exports = {"nft_modal":"styles_nft_modal__smo0j"};